import { GameId } from '../game-settings';

export enum StatType {
  health = 'health',
  armorElectrical = 'armorElectrical',
  armorMechanical = 'armorMechanical',
  powerElectrical = 'powerElectrical',
  powerMechanical = 'powerMechanical',
  speedMove = 'speedMove'
}

// Stat types that may not be specified in the configuration.
export enum OptionalStatType {
  raw = 'raw',
  scaleSpeedAttack = 'scaleSpeedAttack',
  scaleCastRange = 'scaleCastRange',
  scaleDamageIntakeAll = 'scaleDamageIntakeAll',
  scaleDamageIntakeRole = 'scaleDamageIntakeRole' // for debuffs that scales damage intake only for role skills, not part skills.
}

export type AnyStatType = StatType | OptionalStatType;

/** Legacy TF1 sand/rock stats. Delete when old TF is removed. */
export enum StatTypeTf {
  sandSpeedScalar = 'sandSpeedScalar',
  rockSpeedScalar = 'rockSpeedScalar'
}

/** Legacy TF1. Delete when old TF is removed. */
export const terraformingStatToTerrain: Record<StatTypeTf, string> = {
  [StatTypeTf.sandSpeedScalar]: 'sand',
  [StatTypeTf.rockSpeedScalar]: 'rock'
};

export interface IBotStats {
  [GameId.ActionGame]: Record<StatType, number>;
  /** Legacy TF1. Delete entry when old TF is removed. */
  [GameId.Terraforming]: Record<StatTypeTf, number>;
}
